<template>
  <CadastroBase
    nomePlural="FuncionarioPreContratracao"
    nomeSingular="FuncionarioPreContratracao"
    @submitSuccessInsert="emitSubmitSuccess"
    @submitErrorInsert="emitSubmitError"
    @closeModalInsert="closeModal"
  >
    <v-col cols="12">
      <v-row>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="recurso.nome"
            :label="$t('Nome')"
            name="nome"
            obrigatorio
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            v-model="recurso.cpf"
            :label="$t('CPF')"
            name="cpf"
            v-mask="'###.###.###-##'"
            obrigatorio
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <v-text-field
            v-model="recurso.telefone"
            :label="$t('Telefone')"
            name="telefone"
            type="tel"
            inputmode="tel"
            autocomplete="tel"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.nivelSuperior">
            <template v-slot:label>
              {{ $t("Nivel_superior") }}
            </template>
          </v-checkbox>
        </v-col>
      </v-row>
    </v-col>
  </CadastroBase>
</template>

<script>
import CadastroBase from "@/components/base/Crud/CadastroBase";
import DataService from "@/services/pessoal/FuncionarioPreContratracaoDataService";

export default {
  name: "CadastroFuncionarioPreContratracao",
  components: { CadastroBase },
  data() {
    return {
      DataService,
      recurso: {
        telefone: "",
        nivelSuperior: false,
      },
      errors: [],
    };
  },
  methods: {
    emitSubmitSuccess() {
      this.$emit("submitSuccessInsert");
    },
    emitSubmitError() {
      this.$emit("submitErrorInsert");
    },
    closeModal() {
      this.$emit("closeModalInsert");
    },
  },
};
</script>

<style scoped></style>
